import { useEffect, useRef } from 'react';
import {
  applyRemoteUserUiSfxPrefs,
  subscribeUserUiSfxPrefs,
} from '../services/userUiPrefsCloud';

/** Liest Sound-Prefs aus Firestore (Schreiben nur in Task). */
export function useSharedSfxPrefsReadOnly(uid) {
  const lastAppliedAt = useRef(0);

  useEffect(() => {
    if (!uid) return;

    return subscribeUserUiSfxPrefs(uid, (prefs) => {
      if (prefs.updatedAt && prefs.updatedAt <= lastAppliedAt.current) return;
      lastAppliedAt.current = prefs.updatedAt || Date.now();
      applyRemoteUserUiSfxPrefs(prefs);
    });
  }, [uid]);
}
